import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Outlet } from "react-router-dom";
import Header from "../Components/Header/Header";
import Sidebar from "../Components/Sidebar/Sidebar";
import { getUserDetail } from "../Utils/Helper";
import { GoHome } from "react-icons/go";
import { HiClipboardDocumentCheck } from "react-icons/hi2";
import { IoDocument } from "react-icons/io5";
import { MdOutlineGridView, MdOutlineShareLocation } from "react-icons/md";
import { FaUser } from "react-icons/fa6";

const MasterAdminLayout = () => {
    const [sidebarClose, setSidebarClose] = useState(false)

    const closeHandler = () => {
        setSidebarClose(!sidebarClose)
    }

    const dashboardSidebar = [
        ...(getUserDetail()?.role !== 'user' ? [{
            path: "/dashboard",
            icon: <GoHome />,
            title: "Dashboard",
        }] : []),
        ...(getUserDetail()?.role === 'super-admin' ? [{
            path: "/dashboard/all-tenders",
            icon: <MdOutlineGridView />,
            title: "All Tenders",
        }] : []),
        ...(getUserDetail()?.role !== 'user' ? [{
            path: "/dashboard/assigned-tenders",
            icon: <HiClipboardDocumentCheck />,
            title: "Assigned Tenders",
        }] : []),
        {
            path: "/dashboard/interested-tenders",
            icon: <IoDocument />,
            title: "Interested Tenders",
        },
        {
            path: "/dashboard/applied-tenders",
            icon: <MdOutlineShareLocation />,
            title: "Applied Tenders",
        },
        {
            path: "/dashboard/profile",
            icon: <FaUser />,
            title: "Profile",
        },
    ];

    return (
        <>
            <Header />
            <div className={sidebarClose ? "dashboard_div close_leftsider" : "dashboard_div"}>
                <div className="left_dashboard">
                    <div className="close_sidebar">
                        {
                            !sidebarClose ? <IoMdCloseCircleOutline onClick={closeHandler} /> :
                                <GiHamburgerMenu onClick={closeHandler} />
                        }
                    </div>
                    <Sidebar dashboardSidebar={dashboardSidebar} />
                </div>
                <div className="right_dashboard">
                    <Outlet />
                </div>
            </div>
        </>
    );
};
export default MasterAdminLayout;